import React from "react";
import { Box, Tooltip, Link } from "@mui/joy";
import IconButton from "@mui/joy/IconButton";
import "../../css/MenuEscritorio.css";
import ForestIcon from "@mui/icons-material/Forest";
import axios from "axios";
import Avatar from "@mui/joy/Avatar";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/joy/Typography";
import HikingIcon from "@mui/icons-material/Hiking";

export default function MenuAdmin() {
  const menuItemStyles = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: 50,
    color: "text.primary",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "neutral.plainHoverBg",
    },
  };

  let [usuarioprincipal, setUsuarioPrincipal] = React.useState();
  let navigate = useNavigate();
  let url = process.env.REACT_APP_FRONTEND_URL;
  let logo = url + "/uploads/logo.svg";
  let linkimagen = process.env.REACT_APP_DOSPACES;

  React.useEffect(() => {
    let getInfoUsuario = async () => {
      try {
        /* OBTENER BEARER TOKEN */
        let token = localStorage.getItem("token");

        /* OBTENER BEARER TOKEN */

        let infousuario = await axios.get(`${url}/api/usuario/datos-basicos`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUsuarioPrincipal(infousuario.data);
      } catch (err) {
        console.log("Usuario no logeado, redirigiendo...");

        navigate("/iniciar-sesion");
      }
    };
    getInfoUsuario();
  }, []);

  return (
    <Box
      className="menuescritorio"
      sx={{
        width: 80,
        height: "100vh",
        backgroundColor: "background.surface",
        position: "fixed",
        top: 0,
        left: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px 0",
        borderRight: "1px solid",
        borderColor: "neutral.outlinedBorder",
        boxShadow: "sm",
        gap: 3,
      }}
    >
      {/* Logo */}
      <Box
        sx={{
          mb: 4,
          mt: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{
            width: "65%",
            height: "auto",
            borderRadius: "8px",
          }}
        />
      </Box>

      {/* Items del menú */}

      <Tooltip title="Moderar Aventuras" placement="right" arrow>
        <Box sx={menuItemStyles}>
          <IconButton
            sx={{
              display: "grid",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              justifyItems: "center",
            }}
            onClick={() => {
              navigate("/panel/administracion/moderar-aventuras");
            }}
          >
            <Link
              href="/panel/administracion/moderar-aventuras"
              color="inherit"
            >
              <ForestIcon color="inherit" sx={{ color: "#123524" }} />
            </Link>
            <Typography level="body-xs">Moderar Aventuras</Typography>
          </IconButton>
        </Box>
      </Tooltip>
      <Tooltip title="Moderar Usuarios" placement="right" arrow>
        <Box sx={menuItemStyles}>
          <IconButton
            sx={{
              display: "grid",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              justifyItems: "center",
            }}
            onClick={() => {
              navigate("/panel/administracion/moderar-usuarios");
            }}
          >
            <Link href="/panel/administracion/moderar-usuarios" color="inherit">
              <HikingIcon color="inherit" sx={{ color: "#123524" }} />
            </Link>
            <Typography level="body-xs">Moderar Usuarios</Typography>
          </IconButton>
        </Box>
      </Tooltip>

      <Box
        sx={{
          marginTop: "auto",
          marginBottom: "2rem",
          display: "grid",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
          justifyItems: "center",
        }}
      >
        <Link href="/cuenta">
          {usuarioprincipal ? (
            <Avatar
              src={`${linkimagen}/uploads/` + usuarioprincipal.foto_de_perfil}
              variant="soft"
              sx={{ borderRadius: "12px" }}
            />
          ) : null}
        </Link>
        <Typography level="body-xs">Perfil</Typography>
      </Box>
    </Box>
  );
}
